/**
 * Determines if a variable is set and is not NULL
 *
 * @param {mixed} variable - The variable being evaluated
 * @return {boolean}    TRUE if the variable is defined
 */
const isDefined = ( variable ) => {
	// Returns true if the variable is undefined
	return typeof variable !== 'undefined' && variable !== null;
};

export default isDefined;
